import mediumZoom from 'medium-zoom'
import Splide from "@splidejs/splide";


document.addEventListener('DOMContentLoaded', () => {

    const zoom = mediumZoom('[data-zoomable]', {
        margin: 60
    })

    const socialMediaShare = document.querySelector('.gutenberg-social-share')

    zoom.on('close', event => {
        socialMediaShare.classList.remove('is-active')
    })

    zoom.on(
        'opened',
        event => {
            socialMediaShare.classList.add('is-active')
            const image = zoom.getZoomedImage()

            const facebookUrl = 'https://www.facebook.com/sharer.php?u=' + window.location
            const twitterUrl = 'https://twitter.com/share?url=' + window.location
            const pinterestUrl = 'http://pinterest.com/pin/create/button/?url=' + image.src
            const linkedinUrl = 'https://www.linkedin.com/shareArticle?url=' + window.location

            document.querySelector('.js-fb-share').href = facebookUrl
            document.querySelector('.js-twitter-share').href = twitterUrl
            document.querySelector('.js-pin-share').href = pinterestUrl
            document.querySelector('.js-linkedin-share').href = linkedinUrl

        }
    )

    document.querySelectorAll('.c-accordion-grid__item__btn').forEach(function (btn) {
        btn.addEventListener('click', function () {

            const parentSelector = '#accordion-' + this.dataset.slug
            const parentItem = document.querySelector(parentSelector)

            const currentActiveParent = document.querySelector('.c-accordion-grid__item.active')
            const currentActiveBtn = document.querySelector('.c-accordion-grid__item__btn.active')

            this.classList.add('active')
            parentItem.classList.add('active')

            currentActiveParent?.classList.remove('active')
            currentActiveBtn?.classList.remove('active')
        })
    })

    document.querySelectorAll('.splide-gutenberg').forEach(function (splideGb) {

        const splideId = splideGb.getAttribute('data-slide-id')

        const slider = new Splide(splideGb, {
            fixedWidth: '100%',
            fixedHeight: '65.7rem',
            rewind: true,
            pagination: false,
            arrows: false,
            breakpoints: {
                1024: {
                    fixedHeight: '32.3rem',
                },
            },
        })


        const thumbnails = new Splide('.splide-gutenberg-thumbnail-' + splideId, {
            fixedWidth: 'calc((100% / 3) - 1rem)',
            fixedHeight: '25rem',
            gap: '2rem',
            type: 'loop',
            rewind: true,
            pagination: false,
            arrows: false,
            isNavigation: true,
            breakpoints: {
                1024: {
                    fixedWidth: '10rem',
                    fixedHeight: '8rem',
                    gap: '1rem',
                },
            },

        })

        slider.sync(thumbnails)
        slider.mount()
        thumbnails.mount();
    })


})
